"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectDestructuringEmpty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectDestructuringEmpty"));

var _app = require("@package/app");

var _storybook = require("@pikassa/storybook");

var _react = _interopRequireDefault(require("react"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function BasicStatus(_ref) {
  (0, _objectDestructuringEmpty2["default"])(_ref);

  try {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper'],
      "data-locator": 'identification.basic'
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['content']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['label'],
      "data-locator": 'identification.basic.label'
    }, "\u0411\u0430\u0437\u043E\u0432\u044B\u0439 \u0443\u0440\u043E\u0432\u0435\u043D\u044C"), /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
      type: 'comment',
      className: _defaultModule["default"]['text'],
      "data-locator": 'identification.basic.text'
    }, "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u044B \u0432\u0445\u043E\u0434\u044F\u0449\u0438\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u0438 \u0438 \u0432\u044B\u043F\u043B\u0430\u0442\u044B")));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = BasicStatus;
exports["default"] = _default;